import React from 'react';
import './ApiErrorModal.css';

const ApiErrorModal = ({ error, onClose }) => {
  if (!error) return null;

  const { apiName, statusCode, timestamp, errorMessage, parameters, isQueued } = error;

  const handleCopyDetails = () => {
    const detailsText = `
API: ${apiName}
Status Code: ${statusCode}
Queued At: ${timestamp}

ERROR MESSAGE FROM BACKEND:
${errorMessage}

PARAMETERS SENT:
${JSON.stringify(parameters, null, 2)}
    `.trim();

    navigator.clipboard.writeText(detailsText).then(() => {
      alert('Error details copied to clipboard');
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  return (
    <div className="api-error-modal-overlay" onClick={onClose}>
      <div className="api-error-modal" onClick={(e) => e.stopPropagation()}>
        <div className="api-error-modal-header">
          <div className="api-error-modal-title">
            <span className="error-icon">❌</span>
            <h2>{isQueued ? 'Queued API Call Failed' : 'API Call Failed'}</h2>
          </div>
          <button className="api-error-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="api-error-modal-content">
          <div className="error-section">
            <div className="error-info-grid">
              <div className="error-info-item">
                <label>API:</label>
                <span className="error-value">{apiName}</span>
              </div>
              <div className="error-info-item">
                <label>Status Code:</label>
                <span className="error-value error-status">{statusCode}</span>
              </div>
              <div className="error-info-item full-width">
                <label>{isQueued ? 'Queued At:' : 'Failed At:'}</label>
                <span className="error-value">{timestamp}</span>
              </div>
            </div>
          </div>

          <div className="error-section">
            <h3>Error Message from Backend</h3>
            <div className="error-message-box">
              <pre>{errorMessage}</pre>
            </div>
          </div>

          <div className="error-section">
            <h3>Parameters Sent</h3>
            <div className="error-params-box">
              <pre>{JSON.stringify(parameters, null, 2)}</pre>
            </div>
          </div>

          <div className="error-notice">
            <p>
              <strong>Note:</strong> {isQueued 
                ? 'This request was queued while offline and has now failed.' 
                : 'This request failed while processing.'}
              {' '}Please review the error and try the operation again if needed.
            </p>
          </div>
        </div>

        <div className="api-error-modal-footer">
          <button className="btn-copy" onClick={handleCopyDetails}>
            Copy Details
          </button>
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiErrorModal;
